import React, { useState } from 'react';
import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Loader, Dimmer, Button, Message } from 'semantic-ui-react';
import { useProposals } from '../../../providers/ProposalProvider';
import pathianLogo from "../../../assets/PathianLogo.png";
import {useAuth} from "../../../providers/AuthenticationProvider";
import {useNavigate} from "react-router";
const WEB_PAGE = 'Proposals';

const proposalContainerStyle = {
    margin: '1% 5% 1% 5%',
    border: '1px solid #ccc',
    boxShadow: '5px 5px 23px -6px rgba(0,0,0,0.75)',
    padding: '1%'
};

const logoContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1em'
};

const productContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    padding: '1% 0 1% 0'
};

const productHeaderRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '2px solid black'
};

const productRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid grey'
};

const totalRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    fontWeight: 'bold',
    fontSize: '20px',
    margin: '1% 0 1% 0'
};

export const ProposalView = () => {
    const { checkAuth, getUserType } = useAuth();
    const { viewToken } = useParams();
    const { search } = useLocation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [proposalData, setProposalData] = useState(null);
    const [envelopeId, setEnvelopeId] = useState(null);
    const [envelopeStatus, setEnvelopeStatus] = useState(null);
    const [docusignEvent, setDocusignEvent] = useState(null);
    const { getProposalByViewToken, updateEnvelopeStatus, acceptProposal } = useProposals();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        getProposalByViewToken(viewToken)
            .then(data => {
                setLoading(false);
                setProposalData(data.data);
                setEnvelopeId(data.data.envelope?.envelopeId)
                setEnvelopeStatus(data.data.envelope?.status);
            })
            .catch(err => {
                setLoading(false);
                setError(err);
            });
    }, [viewToken, getProposalByViewToken]);

    useEffect(() => {
        const params = new URLSearchParams(search);
        const event = params.get('event');
        setDocusignEvent(event);
        if (envelopeId && event === 'signing_complete') {
            updateEnvelopeStatus(envelopeId, 'verifying');
        }
    }, [search, envelopeId, updateEnvelopeStatus]);

    return (
        <>
            <Message floating negative hidden={!error}>An error occurred. Please try again later.</Message>
            <div style={proposalContainerStyle}>
                <Dimmer active={loading && !proposalData}>
                    <Loader size='massive' active={loading && !proposalData}>Loading Proposal</Loader>
                </Dimmer>
                <Dimmer active={loading && !!proposalData}>
                    <Loader size='massive' indeterminate active={loading && !!proposalData}>Please wait, your invoice is being generated. You will be redirected to Docusign shortly.</Loader>
                </Dimmer>
                {
                    proposalData ?
                        <div>
                            <div style={logoContainerStyle}>
                                <div style={{ width: '33.3%' }}>
                                </div>
                                <div style={{ width: '33.3%', display: 'flex', justifyContent: 'center' }}>
                                    <img
                                        src={proposalData?.distributor?.logoUrl ?? pathianLogo}
                                        alt={proposalData?.distributor?.name ? proposalData?.distributor?.name + " logo" : "Pathian Logo"}
                                        style={{ maxHeight: 70 }}
                                    />
                                </div>
                                <div style={{ width: '33.3%' }}>
                                    {
                                        (envelopeStatus !== 'completed' && docusignEvent !== 'signing_complete') ? (
                                            <Button
                                                style={{
                                                    float: 'right',
                                                    marginRight: '8px',
                                                    backgroundColor: '#5cdb5c',
                                                }}
                                                onClick={() => {
                                                    if (viewToken) {
                                                        setLoading(true);
                                                        acceptProposal(viewToken)
                                                            .then(res => {
                                                                if (res.url) {
                                                                    window.open(res.url, '_self');
                                                                }
                                                            })
                                                            .catch(err => {
                                                                setError(err);
                                                                setLoading(false);
                                                            });
                                                    }
                                                }}
                                            >
                                                Accept
                                            </Button>
                                        ) : null
                                    }
                                </div>

                            </div>
                            {
                                proposalData?.name?.length ?
                                    <h2 style={{ display: 'flex', justifyContent: 'center' }}>{proposalData.name}</h2>
                                    : null
                            }
                            <div dangerouslySetInnerHTML={{ __html: proposalData.opening }}></div>
                            <div style={productContainerStyle}>
                                <div style={productHeaderRowStyle}>
                                    <div style={{ width: '40%', fontWeight: 'bold' }}>
                                        Product
                                    </div>
                                    <div style={{ width: '20%', fontWeight: 'bold' }}>
                                        Quantity
                                    </div>
                                    <div style={{ width: '20%', fontWeight: 'bold', textAlign: 'right' }}>
                                        Price
                                    </div>
                                    <div style={{ width: '20%', fontWeight: 'bold', textAlign: 'right' }}>
                                        Total Cost
                                    </div>
                                </div>
                                {
                                    proposalData?.proposalItems.map((proposalItem) => {
                                        return (
                                            <div style={productRowStyle} key={proposalItem.productId}>
                                                <div style={{ width: '40%' }}>
                                                    {proposalItem.product.name}
                                                </div>
                                                <div style={{ width: '20%' }}>
                                                    {proposalItem.quantity}
                                                </div>
                                                <div style={{ width: '20%', textAlign: 'right' }}>
                                                    {proposalItem.cost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                                </div>
                                                <div style={{ width: '20%', textAlign: 'right' }}>
                                                    {(Math.round(proposalItem.quantity * proposalItem.cost * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={totalRowStyle}>
                                <div>
                                    Grand Total: {proposalData.proposalItems.map(item => (item.cost * item.quantity)).reduce((prev, curr) => prev + curr).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                </div>
                            </div>
                            <div style={{}}>
                                <div dangerouslySetInnerHTML={{ __html: proposalData.termsAndConditions }}></div>
                            </div>
                        </div>
                        : null
                }
            </div>
        </>
    );
};
